import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ParticularsComponent} from './particulars.component';
import {ImagePickerModule} from '../../components/image-picker/image-picker.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [CommonModule, ImagePickerModule, FormsModule, ReactiveFormsModule],
  declarations: [ParticularsComponent],
})
export class ParticularsModule {}
